
function initializePopovers() {
    // find all DOM elements
    var popoverTargets = document.querySelectorAll('.js-rewards-partner-tooltip[data-content], .js-results-tooltip[data-content], .js-pensioner-tooltip[data-content], .js-as-featured-in-tooltip[data-content]');

    // initialize Popover for each element
    Array.from(popoverTargets).map(
        popTarget => new bsn.default.Popover(popTarget, {
            placement: popTarget.hasAttribute('data-placement') ? popTarget.dataset.placement : 'top', //string
            animation: 'slideNfade', // CSS class
            delay: 100, // integer
            dismissible: false, // boolean
        })
    );
}
export {initializePopovers};
